import React, {useEffect, useState} from "react";
import axios from 'axios';
import {ToastsContainer, ToastsContainerPosition, ToastsStore} from "react-toasts";
import {API_URL} from "../../../utils/Common";
import SmallTitleLIne from "../../sharecomponents/SmallTitleLine";
import MyLoader from "../../sharecomponents/MyLoader";
import {restarSemana} from "../../../utils/Common";

const initFormCal = Object.freeze({
    flor: '',
    cantidad_tallos: 0,
    semana_cosecha: ''
});

const initResultado = Object.freeze({
    semanainicio: '',
    transplante: '',
    charolas: '',
    semillas: '',
    plantas: '',
    reqm2: ''
})

const PlanCosecha = (props) => {
    // -- loader
    const [loader, updateLoader] = useState(false);
    // -- Carga de las flores
    const [flores, updateFlores] = useState([]);
    // -- Formulario del Calculo
    const [formCalc,  updateFormCalc] = useState(initFormCal);
    //-- Resultado del calculo
    const [resultado, updateResultado] = useState(initResultado);
    //-- para los ranchos y flores
    const [ranchos, updateRanchos] = useState([]);
    const [valvulas, updateValvulas] = useState([]);
    //-- resultados
    const [totalm2valvulas, updateTotalm2Valvulas] = useState(0);
    const [requeridosm2, updateRequeridosm2] = useState(0);

    useEffect(() => {
        updateLoader(true);
        axios.get(API_URL + '/flor/getFloresRanchos')
            .then(r => {
                updateFlores(r.data.flores);
                updateRanchos(r.data.ranchos);
                updateLoader(false);
            }).catch(err => console.log(err));
    }, []);

    const changeRanchos = e => {
        if (+e.target.value.trim() > 0) {
            let ran = ranchos.find(item => item.id === +e.target.value.trim());
            console.log(ran.valvulas);
            updateValvulas(ran.valvulas);
            //-- calcular el total
            let totalm2Valvulas = 0;
            for (let item of ran.valvulas) {
                totalm2Valvulas += (+item.no_camas * +item.largo);
            }
            updateTotalm2Valvulas(totalm2Valvulas);
        } else {
            updateValvulas([]);
        }
    }

    const changeFormCalc = e => {
        updateFormCalc({
            ...formCalc,
            [e.target.name]: e.target.value.trim()
        });
    }

    const calcular = () => {
        // -- hay que seleccionar una flor
        if (+formCalc.flor > 0) {
            let camas = 1;
            console.log(formCalc);
            //-- revisar la flor
            let flor = flores.find(item => item.id === +formCalc.flor)
            console.log(flor);

            //-- calculando las semillas
            let plantasReq = +formCalc.cantidad_tallos / flor.porcentaje;
            let m2requeridos = plantasReq / +flor.densidadm2;
            let nocharolas = ((plantasReq * camas) / +flor.germinacion) / +flor.cavidad;
            let semillasReq = nocharolas * +flor.cavidad;
            // -- actualizar los m2 requeridos
            updateRequeridosm2(m2requeridos);

            // -- caculo de las semanas
            let sc = (formCalc.semana_cosecha + "").substring(2, 4);
            // console.log('sc', sc);
            let semanainicio = restarSemana(20, +sc, (flor.propagacion + flor.ciclocampo));
            // console.log('si', semanainicio);
            let transplante = restarSemana(20, +sc, flor.ciclocampo);
            // console.log('tr', transplante);

            let resultadoFinal = {
                semanainicio: semanainicio.cadena,
                transplante: transplante.cadena,
                charolas: nocharolas.toFixed(2),
                semillas: semillasReq.toFixed(2),
                plantas: plantasReq.toFixed(2),
                reqm2: m2requeridos.toFixed(2)
            }

            updateResultado(resultadoFinal);
        } // -- if
        else {
            ToastsStore.error("Seleccione una Flor para ralizar el cálculo");
        }

        //-- Simulación de tiempo de cálculo
        /*updateLoader(true);
        setTimeout(function () {
            updateResultado(resultadoFinal);
            updateLoader(false);
        }, 1000); */
    }

    return (
        <div className="w-full p-3">
            <div className="bg-white border rounded shadow-xl">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    <h5 className="font-bold uppercase text-white">Calculadora de Cosecha</h5>
                    <p className="text-white text-sm">Cálculo del Cosecha y Disponibilidad</p>
                </div>
                <div className="p-5 rounded-b">
                    <div className="grid grid-cols-2 gap-1">
                        <div className="text-sm p-2 m-1 rounded-lg shadow-xl border border-orange-100">
                            {/** Formulario para generar el plan */}
                            <form className="mb-3">
                                <div className="mx-2 my-2">
                                    <label className="block uppercase tracking-wide text-gray-700 font-bold mb-2">
                                        Flor:
                                    </label>
                                    <div className="relative">
                                        <select className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                name="flor" id="flor"
                                                onChange={changeFormCalc}>
                                            <option value="Ninguno">Ninguno</option>
                                            {
                                                flores.map((f, i) => {
                                                    return (
                                                        <option key={f.id} value={f.id}>{f.nombre_comun}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 20 20">
                                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-2 gap-1">
                                    <div className="mx-2 my-2">
                                        <label className="block uppercase tracking-wide text-gray-700 font-bold mb-2">
                                            Cantidad Tallos:
                                        </label>
                                        <input className="text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                               type="number" name="cantidad_tallos"
                                               onChange={changeFormCalc}/>
                                    </div>
                                    <div className="mx-2 my-2">
                                        <label className="block uppercase tracking-wide text-gray-700 font-bold mb-2">
                                            Semana Cosecha(yyww):
                                        </label>
                                        <input className="text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                               type="text" name="semana_cosecha"
                                               onChange={changeFormCalc}/>
                                    </div>
                                </div>
                                <div className="mx-2 my-2 inline-flex">
                                    <button type="button"
                                            className="text-sm mr-2 bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow focus:outline-none"
                                            onClick={calcular}>
                                        <i className="fas fa-calculator mr-1" /> Calcular
                                    </button>
                                </div>
                            </form>
                            {/** ./Formulario para generar el plan */}
                            <div className="bg-white rounded-lg">
                                <div className="px-4 py-5 border-t border-orange-200 sm:px-6">
                                    <h3 className="text-lg uppercase leading-6 font-medium text-orange-900">
                                        Resultado
                                    </h3>
                                    <p className="mt-1 max-w-2xl text-sm leading-5 text-gray-600">
                                        Cálculo generado en base lo seleccionado en el formulario
                                    </p>
                                </div>
                                <div className="text-sm font-medium text-gray-600">
                                    <dl>
                                        <div className="bg-orange-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="leading-5">
                                                SEMANA DE INICIO:
                                            </dt>
                                            <dd className="mt-1 leading-5 text-orange-900 sm:mt-0 sm:col-span-2">
                                                { resultado.semanainicio }
                                            </dd>
                                        </div>
                                        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="leading-5">
                                                TRANSPLANTE:
                                            </dt>
                                            <dd className="mt-1 text-sm leading-5 text-orange-900 sm:mt-0 sm:col-span-2">
                                                { resultado.transplante }
                                            </dd>
                                        </div>

                                        <div className="bg-orange-200 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="leading-5 font-bold">
                                                PLANTAS:
                                            </dt>
                                            <dd className="mt-1 text-sm font-bold leading-5 text-orange-900 sm:mt-0 sm:col-span-2">
                                                { resultado.plantas } Pzs
                                            </dd>
                                        </div>
                                        <div className="bg-orange-200 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="leading-5 font-bold">
                                                REQUERIDO(m2):
                                            </dt>
                                            <dd className="mt-1 text-sm font-bold leading-5 text-orange-900 sm:mt-0 sm:col-span-2">
                                                { resultado.reqm2 } m2
                                            </dd>
                                        </div>
                                        <div className="bg-orange-200 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="leading-5 font-bold">
                                                CHAROLAS:
                                            </dt>
                                            <dd className="mt-1 text-sm font-bold leading-5 text-orange-900 sm:mt-0 sm:col-span-2">
                                                { resultado.charolas }
                                            </dd>
                                        </div>
                                        <div className="bg-orange-200 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                            <dt className="leading-5 font-bold">
                                                SEMILLAS:
                                            </dt>
                                            <dd className="mt-1 text-sm font-bold leading-5 text-orange-900 sm:mt-0 sm:col-span-2">
                                                { resultado.semillas }
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <div className="text-sm p-2 m-1 rounded-lg shadow-xl border border-orange-100">
                            {/** Resultado del cálculo del Plan */}
                            <SmallTitleLIne titulo="Disponibilidad en Camas" />
                            {/** ./Resultado del cálculo del Plan */}
                            {/** Formulario */}
                            <form>
                                <div className="inline-flex mx-2 my-2">
                                    <div>
                                        <label className="block uppercase tracking-wide text-gray-700 font-bold mb-2">
                                            Rancho:
                                        </label>
                                        <div className="relative">
                                            <select className="block uppercase appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    name="rancho" id="rancho"
                                                    onChange={changeRanchos}>
                                                <option value="0">Ninguno</option>
                                                {
                                                    ranchos.map((r, i) => {
                                                        return (
                                                            <option key={r.id} value={r.id}>{r.nombre}</option>
                                                        );
                                                    })
                                                }
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                     viewBox="0 0 20 20">
                                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            {/** ./Formulario */}
                            {/** tabla de disponibilidad */}
                            <table className="table-fixed mt-5 w-full">
                                <thead>
                                <tr className="border border-orange-800 text-xs text-white content-center bg-orange-800">
                                    <th className="px-4 py-2">No. Valvula</th>
                                    <th className="px-4 py-2">No. Camas</th>
                                    <th className="px-4 py-2">Largo</th>
                                    <th className="px-4 py-2">Camas Disponibles</th>
                                    <th className="px-4 py-2">m2 Disponibles</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    valvulas.map((v, i) => {
                                        return (
                                            <tr key={i}>
                                                <td className="border px-4 py-2">{"Valv-"+v.id}</td>
                                                <td className="text-right border px-4 py-2">{v.no_camas}</td>
                                                <td className="text-right border px-4 py-2">{v.largo+' m'}</td>
                                                <td className="text-right border px-4 py-2">{v.no_camas}</td>
                                                <td className="text-right border px-4 py-2">{(v.no_camas * v.largo).toFixed(2)+' m2'}</td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th className="text-right border px-4 py-2" colSpan="4">
                                        Total M2:
                                    </th>
                                    <th className="text-right border px-4 py-2">{ totalm2valvulas.toFixed(2) + ' m2' }</th>
                                </tr>
                                <tr>
                                    <th className="text-right border px-4 py-2" colSpan="4">
                                        Requeridos M2:
                                    </th>
                                    <th className={totalm2valvulas > requeridosm2 ? "text-right border px-4 py-2 bg-green-200":"text-right border px-4 py-2 bg-red-200"}>{ requeridosm2.toFixed(2) + ' m2' }</th>
                                </tr>
                                </tfoot>
                            </table>
                            {/** ./tabla de disponibilidad */}
                        </div>
                    </div>
                </div>
            </div>
            {/** loading **/}
            { loader &&
                <MyLoader />
            }
            {/** ./loading **/}
            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>
        </div>
    );
}

export default PlanCosecha;
